// Google Analytics 4 (gtag.js) — loaded ONLY after statistics consent (GDPR/TTDSG).
import { hasStatisticsConsent } from '@/lib/consent';

const GA_ID = 'G-5PYK9LZRK0';
let loaded = false;

export function initGA() {
  if (loaded || typeof window === 'undefined') return;
  if (!hasStatisticsConsent()) return;
  loaded = true;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  // We send page_view manually on SPA route changes.
  window.gtag('config', GA_ID, { send_page_view: false, anonymize_ip: true });
}

export function gaPageview(path) {
  if (!loaded || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function gaEvent(name, params = {}) {
  if (!loaded || typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, params);
}

export const GA_MEASUREMENT_ID = GA_ID;
